import { useModal } from '../../../../../../../bootstrap/application/components/app/components/ModalProvider/ModalProvider.context';
import { RouteNames } from '../../../../../../../bootstrap/domain/RouteNames';
import { QrCodeModal } from '../../../../../../../shared/application/components/QrCodeModal/QrCodeModal';
import { useNavigation } from '../../../../../../../shared/application/hooks/useNavigation';
import { splitSessionCodeByDash } from '../../../../../../../shared/application/utils/splitSessionCodeByDash';
import { useHostClientContext } from '../../HostClientProvider/hooks/useHostClientContext';

export const useOpenQrCodeModal = () => {
  const { client } = useHostClientContext();
  const { openModal, closeModal } = useModal();
  const { getFullUrl } = useNavigation();

  const openQrCodeModal = () => {
    if (client.game.isSessionBlocked) {
      return;
    }

    const { geniallyId, sessionId } = client;

    const url = `${getFullUrl({
      to: RouteNames.PlayerUsernameSelection,
      params: { geniallyId, sessionId },
    })}?from=game`;

    openModal(parentElement => (
      <QrCodeModal
        url={url}
        sessionId={splitSessionCodeByDash(sessionId)}
        geniallyId={geniallyId}
        parentElement={parentElement}
        closeModal={closeModal}
        openedFrom={client.game.isStarted ? 'game' : 'lobby'}
      />
    ));
  };

  return { openQrCodeModal };
};
